/* global swal angular */
import './style.less';

export default function($scope, $log, $state, $stateParams, ApiClass, ProfileClass) {
  'ngInject';

  const form_id = $stateParams.form_id;
  const { company_id } = ProfileClass.profileComplete.profile;

  const vm = this;

  vm.$onInit = activate;

  vm.stateParams = $stateParams;

  vm.courseInfo = {
    by: 'Author Name',
    delivery_date: new Date(Date.now()),
    hours: [
      {
        category_id: '92a86735-5fc7-4eb6-a42d-250b953f4dd2',
        credits: 3,
        subject_area: 'Accounting'
      }
    ],
    instructors: [
      {
        email: 'ChloeOBrian@24.com',
        first: 'Chloe',
        last: "O'Brian",
        time: 1
      },
      {
        email: 'jackBower@24.com',
        first: 'Jack',
        last: 'Bauer',
        time: 1
      }
    ],
    location: 'Seattle, WA',
    logo: false,
    name: 'Course Name'
  };

  vm.activateForm = () => {
    return ApiClass.companiesIdTypeTypeIdPatch(
      { manage: true, id: company_id, type: 'evaluationForms', type_id: $stateParams.form_id },
      { active: true }
    )
      .then(() => $state.go('app.author.evaluationForms', $stateParams))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    ApiClass.companiesIdTypeTypeIdGet({ manage: true, id: company_id, type: 'evaluationForms', type_id: form_id }, null)
      .then(({ data: { item } }) => {
        vm.formData = item;
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/author/evaluationForms/view/controller.js